
import { defineComponent, reactive, toRefs } from 'vue';
import Overlay from '../../components/Overlay.vue';
import VChart from 'vue-echarts';

export default defineComponent({
  name: 'DashboardGoalBilled',

  components: {
    Overlay,
    VChart,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    totalGoal: {
      type: Array as () => Array<number>,
      default: () => [],
    },

    totalBilled: {
      type: Array as () => Array<number>,
      default: () => [],
    },

    month: {
      type: Array as () => Array<string>,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const propsRef = toRefs(props);
    const state = reactive({
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          top: '5%',
          left: '12%',
          right: '4%',
          bottom: '12%',
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.1],
          inverse: true,
        },
        yAxis: {
          type: 'category',
          data: propsRef.month,
        },
        series: [
          {
            name: 'Meta mês',
            type: 'bar',
            data: propsRef.totalGoal,
            color: '#999697',
            label: {
              show: true,
              position: 'left',
              color: '#000000',
              formatter: (i: any) => {
                return i.data[1] == 0 ? '' : i.data[1];
              },
            },
          },
          {
            name: 'Faturado',
            type: 'bar',
            data: propsRef.totalBilled,
            color: '#219653',
            label: {
              show: true,
              position: 'left',
              color: '#000000',
              formatter: (i: any) => {
                return i.data[1] == 0 ? '' : i.data[1];
              },
            },
          },
        ],
      },
    });
    return { ...toRefs(state) };
  },
});
